import axios from "../config/axios";
import * as api from "../routes/userroutefront";
import { refreshWalletAfterMutation } from "../../utility/walletRefresh";

const result = (r) => ({ status: r.data?.status, message: r.data?.message, result: r.data?.result });
const failure = (e) => ({ status: false, message: e.response?.data?.message || "Request failed." });
export const getRedemptionLimits = () => axios.get(api.redemptionLimits).then(result).catch(failure);
export const getRedemptionHistory = () => axios.get(api.redemptionHistory).then(result).catch(failure);
export const submitRedemption = (data) => axios.post(api.redemptionRequest, data).then(r => refreshWalletAfterMutation(result(r))).catch(failure);
